var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faSearchMinus } from "@fortawesome/pro-regular-svg-icons";
import { faExternalLinkAlt, faUndo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Icon } from "antd";
import React from "react";
import { SVG } from "../../assets";
var EmptyTextView = /** @class */ (function (_super) {
    __extends(EmptyTextView, _super);
    function EmptyTextView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.render = function () {
            var _a = _this.props, emptyText = _a.emptyText, source = _a.source, onClearFilter = _a.onClearFilter, onClose = _a.onClose, onOpenHelpCenter = _a.onOpenHelpCenter, filterButtonProps = _a.filterButtonProps, noData = _a.noData;
            return (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                noData ?
                    React.createElement(Icon, { style: { fontSize: "90px", borderRadius: '50%', backgroundColor: "#F2F8FC", padding: "61px" }, className: "cursor-pointer color-blue-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearchMinus }); } }) :
                    React.createElement(Icon, { style: { fontSize: "90px", borderRadius: '50%', backgroundColor: "#F2F8FC", padding: "57px 42px" }, className: "cursor-pointer color-blue-5", component: function () { return React.createElement(SVG.EmptyTextIcon, null); } }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("div", { className: "strong", style: { fontSize: '36px' } }, emptyText),
                React.createElement("br", null),
                React.createElement("br", null),
                source === "GRID" ?
                    onClearFilter && !noData &&
                        React.createElement(React.Fragment, null,
                            React.createElement(Button, { className: "cursor-pointer", onClick: onClearFilter, type: "primary" }, filterButtonProps ? filterButtonProps :
                                React.createElement("span", null,
                                    "  ",
                                    React.createElement(FontAwesomeIcon, { icon: faUndo }),
                                    React.createElement("span", { className: "margin-left-xs" }),
                                    React.createElement("b", null, "Clear filters"))),
                            React.createElement("span", { className: "margin-left-lg" })) :
                    onClose &&
                        React.createElement(React.Fragment, null,
                            React.createElement(Button, { className: "cursor-pointer margin-left-xl", onClick: onClose, type: "primary" }, filterButtonProps ? filterButtonProps :
                                React.createElement("b", null, "Close")),
                            React.createElement("span", { className: "margin-left-lg" })),
                React.createElement(Button, { className: "cursor-pointer", onClick: function () { return onOpenHelpCenter ? onOpenHelpCenter : window.open("https://solutions.yodlee.com/My-Yodlee-Help.html", "_blank"); } },
                    React.createElement(Icon, { className: "font-size-xl cursor-pointer color-blue-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faExternalLinkAlt }); } }),
                    React.createElement("span", { className: "margin-left-sm" }),
                    "Open help center")));
        };
        return _this;
    }
    return EmptyTextView;
}(React.Component));
export default EmptyTextView;
//# sourceMappingURL=index.js.map